import React, { Component } from "react";
import { isSimulating } from "@culturehq/client";
import { PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import Simulate from "./Simulate";

class SimulationBannerContext extends Component {
  state = { simulationUserId: null };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isSimulating()) {
      return { simulationUserId: null };
    }

    if (nextProps.profile.id !== prevState.simulationUserId) {
      return { simulationUserId: nextProps.profile.id };
    }

    return null;
  }

  render() {
    const { simulationUserId } = this.state;

    if (simulationUserId === null) {
      return null;
    }

    return (
      <div className="sim">
        <strong>
          <Trans>Careful.</Trans>
        </strong>
        {" "}
        <Trans>
          You are simulating a user. Any actions you take will be performed
          on their behalf.
        </Trans>
        <Simulate>
          {onTrigger => (
            <PlainButton className="sim--end" onClick={onTrigger}>
              <Trans>End Simulation</Trans>
            </PlainButton>
          )}
        </Simulate>
      </div>
    );
  }
}

const SimulationBanner = () => {
  const { profile } = useProfile();

  return <SimulationBannerContext profile={profile} />;
};

export default SimulationBanner;
